/* eslint-disable @typescript-eslint/no-explicit-any */
import { openDB } from 'idb';

const DB_NAME = 'pabandi-portal-cache';
const STORE_NAME = 'api-cache';

export const getDB = () =>
  openDB(DB_NAME, 1, {
    upgrade(db:any) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });

export const getCachedResponse = async (key: string) => {
  const db = await getDB();
  return db.get(STORE_NAME, key);
};

export const setCachedResponse = async (key: string, data: any) => {
  const db = await getDB();
  await db.put(STORE_NAME, data, key);
};

export const deleteCachedResponse = async (key: string) => {
  const db = await getDB();
  await db.delete(STORE_NAME, key);
};

export const clearCache = async () => {
  const db = await getDB();
  await db.clear(STORE_NAME);
};
